import { NgClass } from "@angular/common";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslatePipe } from "@commonNodeModules/@ngx-translate/core";
import { CatalogSearchResultDisplayType } from "@enums/catalog-search-result-display-type";
import { CatalogViewForeignLanguageCatalogsDto, CatalogViewRelatedCatalogsDto } from "@interfaces/HttpClient/CatalogApiPublicModels";
import { SearchFilterId } from "@interfaces/HttpClient/SearchApiModels";
import { ICatalogQueryParams, ICatalogRoutingParams } from "@interfaces/iCatalogRoutingParams";
import { TagModel } from "@interfaces/iTagFilter";
import { CatalogIntegrationSettingsService } from "@services/catalog-integration-settings.service";
import { CatalogSearchresultModel, SearchResultService } from "@services/search-result.service";
import { SearchService } from "@services/search.service";
import { SearchbarService } from "@services/searchbar.service";
import { NewsListComponent } from "../../../components/news-list/news-list.component";
import { CatalogTagviewerComponent } from "../../../viewers/catalog-tagviewer/catalog-tagviewer.component";
import { CatalogSearchbarComponent } from "../catalog-searchbar/catalog-searchbar.component";
import { MoreCatalogsComponent } from "../more-catalogs/more-catalogs.component";

@Component({
	selector: "app-catalog-navigation",
	templateUrl: "./catalog-navigation.component.html",
	styleUrls: ["./catalog-navigation.component.scss"],
	imports: [NgClass, CatalogSearchbarComponent, CatalogTagviewerComponent, NewsListComponent, TranslatePipe, MoreCatalogsComponent]
})
export class CatalogNavigationComponent implements OnInit {

	@Input() currentRoutingParams: ICatalogRoutingParams;
	@Input() currentQueryParams: ICatalogQueryParams;
	@Input() languageCatalogs: CatalogViewForeignLanguageCatalogsDto[];
	@Input() relatedCatalogs: CatalogViewRelatedCatalogsDto[];
	@Input() catalogKey: string;
	@Input() categoryGroups: { title: string, id: number }[];
	@Input() minimized: boolean;
	@Input() hasNews: boolean;
	@Output() emptySearch = new EventEmitter();
	@Output() minimize = new EventEmitter();
	@Output() openNews = new EventEmitter<number>();
	@Input() defaultTags: TagModel[];
	@Input() selectedTags: TagModel[];
	@Input() tags: TagModel[];
	@Input() catalogSearchResultModel: CatalogSearchresultModel = { catalogFilterEntries: [], displayType: CatalogSearchResultDisplayType.Catalog, isEmptySearch: false, searchTags: [] };
	public displayType = CatalogSearchResultDisplayType;
	public hasSomeNews = false;
	public searchFilterId = SearchFilterId;
	public displayModes: any[];
	public currentPage = 1;
	public showForeignLanguageCatalogs: boolean
	public showRelatedCatalogs: boolean
	public canNavigateToStartingPage: boolean

	constructor(
		public route: ActivatedRoute,
		public router: Router,
		public searchResultService: SearchResultService,
		public searchbarService: SearchbarService,
		public searchService: SearchService,
		public catalogIntegrationSettingsService: CatalogIntegrationSettingsService
	) { }

	ngOnInit() {
		this.displayModes = [
			{
				displayString: "catalog-view.as-list",
				value: CatalogSearchResultDisplayType.List,
				image: "list-mask-img"
			},
			{
				displayString: "catalog-view.as-catalog",
				value: CatalogSearchResultDisplayType.Catalog,
				image: "closed-folder-mask-img"
			}
		];

		this.route.queryParams.subscribe(pars => {
			let page: (number | string) = pars.searchPage;
			if (page) {
				page = parseInt(pars.searchPage, null);
				this.currentPage = Number.isNaN(page) || page < 1 ? 1 : page;
			}
		});
		this.catalogIntegrationSettingsService.settings$.subscribe(settings => {
			this.showForeignLanguageCatalogs = settings?.showForeignLanguageCatalogs
			this.showRelatedCatalogs = settings?.showRelatedCatalogs
			this.canNavigateToStartingPage = settings?.canNavigateToStartingPage
		})
	}

	public async tagClicked(tags: TagModel[]) {
		this.searchResultService.catalogSearchTrigger.emit(true);
		await this.searchResultService.navigate(this.searchService, this.router, this.catalogSearchResultModel.displayType, this.currentRoutingParams, this.selectedTags, false, tags);
	}


	public showDisplayType() {
		return this.currentRoutingParams?.view !== undefined;
	}



	async showresults(val: CatalogSearchResultDisplayType): Promise<void> {
		this.catalogSearchResultModel.displayType = val;
		// this.navigate();
		await this.navigateTo(this.currentRoutingParams.catalogItemGuid);
	}

	private async navigateTo(catalogItemGuid: string) {
		let route = ["catalog", this.currentRoutingParams.key];

		if (catalogItemGuid) {
			route = route.concat(["catalogItem", catalogItemGuid])
		}
		route.push("search");
		await this.router.navigate(route, { queryParams: { searchPage: this.currentPage, searchResultDisplayType: this.catalogSearchResultModel.displayType }, queryParamsHandling: 'merge' });
	}

	public async resetFilter() {
		await this.searchResultService.navigate(this.searchService, this.router, this.catalogSearchResultModel.displayType, this.currentRoutingParams, this.selectedTags, true);
	}

	public get disabledFilter() {
		return !(!!this.currentQueryParams.searchFilter);
	}

	public get isSearching() {
		return this.searchResultService.isSearching();
	}


}
